/** Output languages */
export const OUTPUT_LANGUAGES = {
    default: 'Default',
    arabic: 'Arabic',
    bulgarian: 'Bulgarian',
    catalan: 'Catalan',
    chineseSimplified: 'Chinese (Simplified)',
    chineseTraditional: 'Chinese (Traditional)',
    croatian: 'Croatian',
    czech: 'Czech',
    danish: 'Danish',
    dutch: 'Dutch',
    english: 'English',
    estonian: 'Estonian',
    finnish: 'Finnish',
    french: 'French',
    german: 'German',
    germanSwiss: 'German (Swiss)',
    greek: 'Greek',
    hebrew: 'Hebrew',
    hindi: 'Hindi',
    hungarian: 'Hungarian',
    indonesian: 'Indonesian',
    italian: 'Italian',
    japanese: 'Japanese',
    korean: 'Korean',
    latvian: 'Latvian',
    lithuanian: 'Lithuanian',
    malay: 'Malay',
    norwegian: 'Norwegian',
    polish: 'Polish',
    portugueseBrazilian: 'Portuguese (Brazilian)',
    portugueseEuropeanRomanian: 'Portuguese (European)Romanian',
    russian: 'Russian',
    serbian: 'Serbian',
    slovak: 'Slovak',
    slovenian: 'Slovenian',
    spanish: 'Spanish',
    swedish: 'Swedish',
    thai: 'Thai',
    turkish: 'Turkish',
    ukrainian: 'Ukrainian',
    vietnamese: 'Vietnamese',
    cantonese: 'Cantonese',
};
